export function useMoneyFormat(
  currency: MaybeRefOrGetter<string>,
  defaultOptions?: Intl.NumberFormatOptions,
) {
  function toMoney(amount: number, options?: Intl.NumberFormatOptions) {
    return formatCurrency(amount, options ?? defaultOptions, toValue(currency))
  }

  return { toMoney }
}
